import React, {Component} from 'react';
import Menu from "../components/Menu";
import Axios from "axios";
import ApiUrl from "../AppUrl/ApiUrl";
import {toast} from "react-toastify";
import Loading from "../components/Loading";

class Settings extends Component {
    constructor(props) {
        super(props);
        this.state = {
            token: "",
            ads_price: "",
            claim_price: "",
            reg_bonus: "",
            referral_bonus: "",
            withdraw_type: "",
            point_price: "",
            min_withdraw: "",
            loading: true,
        }
    }

    async componentDidMount() {
        var token = localStorage.getItem("admintoken");
        this.setState({ token: token });

        try {
            const res = await Axios.get(ApiUrl.baseurl + "get-settings");
            if (res.data) {
                const settingsData = res.data.data || res.data;
                this.setState({
                    ads_price: settingsData.ads_price || "",
                    claim_price: settingsData.claim_price || "",
                    reg_bonus: settingsData.reg_bonus || "",
                    referral_bonus: settingsData.referral_bonus || "",
                    withdraw_type: settingsData.withdraw_type || "",
                    point_price: settingsData.point_price || "",
                    min_withdraw: settingsData.min_withdraw || "",
                    loading: false
                });
            }
        } catch (error) {
            console.log(error);
            this.setState({ loading: false });
            toast.error("Failed to load settings data");
        }
    }

    onChangeInput = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    }

    onSubmitForm = (event) => {
        event.preventDefault();
        var val = this.state;

        var formData = new FormData();
        formData.append("token", val.token);
        formData.append("ads_price", val.ads_price);
        formData.append("claim_price", val.claim_price);
        formData.append("reg_bonus", val.reg_bonus);
        formData.append("referral_bonus", val.referral_bonus);
        formData.append("withdraw_type", val.withdraw_type);
        formData.append("point_price", val.point_price);
        formData.append("min_withdraw", val.min_withdraw);

        Axios.post(ApiUrl.baseurl + "settings/update", formData)
            .then(res => {
                if(res.data.success){
                    toast.success(res.data.success, {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });

                } else {
                    toast.error(res.data.error || "Something went wrong", {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                }
            })
            .catch(error => {
                console.log(error);
                toast.error(error.response?.data?.error || "Server error occurred");
            });
    }

    render() {
        return (
            <Menu title="Settings">
                <h3 className="bg-white title-head"> System Settings </h3>
                <div className="container-fluid currency-add">
                    <div className="row">
                        <div className="col-md-12">
                            {this.state.loading === true ?
                                <Loading /> :
                                <form onSubmit={this.onSubmitForm}>
                                    <div className="row">
                                        <div className="col-md-6 mb-3">
                                            <label>Ads Price</label>
                                            <input
                                                type="text"
                                                name="ads_price"
                                                required
                                                value={this.state.ads_price}
                                                onChange={this.onChangeInput}
                                                className="form-control shadow-none"
                                                placeholder="Enter ads price"
                                            />
                                        </div>
                                        <div className="col-md-6 mb-3">
                                            <label>Claim Price</label>
                                            <input
                                                type="text"
                                                name="claim_price"
                                                required
                                                value={this.state.claim_price}
                                                onChange={this.onChangeInput}
                                                className="form-control shadow-none"
                                                placeholder="Enter claim price"
                                            />
                                        </div>
                                        <div className="col-md-6 mb-3">
                                            <label>Registration Bonus</label>
                                            <input
                                                type="text"
                                                name="reg_bonus"
                                                required
                                                value={this.state.reg_bonus}
                                                onChange={this.onChangeInput}
                                                className="form-control shadow-none"
                                                placeholder="Enter registration bonus"
                                            />
                                        </div>
                                        <div className="col-md-6 mb-3">
                                            <label>Referral Bonus</label>
                                            <input
                                                type="text"
                                                name="referral_bonus"
                                                required
                                                value={this.state.referral_bonus}
                                                onChange={this.onChangeInput}
                                                className="form-control shadow-none"
                                                placeholder="Enter referral bonus"
                                            />
                                        </div>
                                        <div className="col-md-6 mb-3">
                                            <label>Withdraw Type</label>
                                            <input
                                                type="text"
                                                name="withdraw_type"
                                                required
                                                value={this.state.withdraw_type}
                                                onChange={this.onChangeInput}
                                                className="form-control shadow-none"
                                                placeholder="Enter withdraw type"
                                            />
                                        </div>
                                        <div className="col-md-6 mb-3">
                                            <label>Point Price</label>
                                            <input
                                                type="text"
                                                name="point_price"
                                                required
                                                value={this.state.point_price}
                                                onChange={this.onChangeInput}
                                                className="form-control shadow-none"
                                                placeholder="Enter point price"
                                            />
                                        </div>
                                        <div className="col-md-6 mb-3">
                                            <label>Minimum Withdraw</label>
                                            <input
                                                type="text"
                                                name="min_withdraw"
                                                required
                                                value={this.state.min_withdraw}
                                                onChange={this.onChangeInput}
                                                className="form-control shadow-none"
                                                placeholder="Enter minimum withdraw amount"
                                            />
                                        </div>
                                        <div className="col-md-12 mt-4 mb-5">
                                            <button type="submit" className="btn btn-primary shadow-none">Update Settings</button>
                                        </div>
                                    </div>
                                </form>
                            }
                        </div>
                    </div>
                </div>
            </Menu>
        );
    }
}

export default Settings;